import MesureFormController from './mesure.form.controller';

export default {
    template: require('./mesure.form.html'),
    controller: MesureFormController
};
